import { fetchApi } from '../utils/fetchApi'

export const getSchema = ({ path }) => fetchApi({
  path: `${path}/schema`,
})
